import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../authentication/login/login.service';
import { UserRight } from '../../authentication/login/user.model';
import { ConfigurationService } from '../../configuration/configuration.service';
import { DestroyService } from '../../shared/destroy.service';
import { ThemeService } from '../../theme/theme.service';
import { FullscreenService } from './fullscreen.service';
import { PeriodService } from '../period-picker/period.service';
import { cardRights, SETTING_CARDS } from '../../../settings/setting.model';
import { HighlightService } from './help-drawer/highlight.service';

export class SidenavLink {
  title: string;
  path: string;
  icon?: string;
  useQueryParams?: boolean;
  rights: UserRight[];
}

@Component({
  selector: 'core-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  providers: [DestroyService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SidenavComponent implements OnInit {
  @Input() project: 'settings' | 'dashboards';
  menuItems: SidenavLink[] = [
    {
      path: `${environment.urlDashboards}/dashboards`,
      title: $localize`Dashboards`,
      icon: 'dashboard',
      useQueryParams: true,
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/measures`,
      title: $localize`Explore`,
      icon: 'explore',
      useQueryParams: true,
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/scoring`,
      title: $localize`Scoring`,
      icon: 'speed',
      useQueryParams: true,
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/monitoring`,
      title: $localize`Monitoring`,
      icon: 'stream',
      useQueryParams: true,
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/traffic`,
      title: $localize`Traffic`,
      icon: 'traffic',
      useQueryParams: true,
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/events`,
      title: $localize`Events`,
      icon: 'event_note',
      rights: [],
    },
    {
      path: `${environment.urlDashboards}/settings`,
      title: $localize`Settings`,
      icon: 'settings',
      rights: SETTING_CARDS.some(card => cardRights(card).length === 0)
        ? []
        : SETTING_CARDS.flatMap(card => cardRights(card)),
    },
  ];
  version = '';
  isFullscreen = false;

  constructor(
    public loginService: LoginService,
    public dialog: MatDialog,
    private fullscreenService: FullscreenService,
    private $destroy: DestroyService,
    public themeService: ThemeService,
    public configurationService: ConfigurationService,
    public periodService: PeriodService,
    public highlightService: HighlightService
  ) {}

  ngOnInit(): void {
    this.version = document.querySelector(`meta[name='version']`)?.getAttribute('content');
    this.fullscreenService.isFullscreen$
      .pipe(takeUntil(this.$destroy))
      .subscribe(isFullscreen => (this.isFullscreen = isFullscreen));
  }

  helpDrawerOpened(): void {
    this.highlightService.markAsRead();
  }
}
